<template>
  <div></div>
</template>

<script lang="ts">
import { Content, Sequence } from '@forchange/storytime';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import initSpecial, { PracticeCourtOptions } from '../PracticeCourt/initSpecial';

import { namespace } from 'vuex-class';
import { PracticeCourt } from '@/store/modules/common/types';

const userModule = namespace('common');

@Component
export default class UpdatePracticeCourt extends Vue {
  @Prop({ type: Object }) content!: Content & {
    iframePath: string;
    viewPercent: number | undefined;
    // 注意同步更行PracticeCourt
    type: 'vika' | undefined;
    options: PracticeCourtOptions | undefined;
  };

  @userModule.State('practiceCourt') public practiceCourt!: PracticeCourt;

  mounted() {
    if (window.storyteller.topContet?.$id !== this.content.$id) return;
    if (this.practiceCourt.visible) {
      this.$Message.info({
        time: 1500,
        content: '正在打开新的练习模板'
      });
      this.arouseCleword();
    }
    window.next();
  }

  async arouseCleword() {
    // 接口请求拿到模板链接
    const iframeUrl = await this.getIframeUrl();
    const postMessage = {
      protocol: 'cleword-system',
      command: 'update_double_column',
      iframeUrl: iframeUrl?.url || '',
      viewPercent: this.content.viewPercent,
      desktopOptions: { instanceId: iframeUrl?.instanceId, ...(this.content.options || {}) }
    };
    if (!this.$PostConnection) return;
    this.$PostConnection.command('update_double_column', postMessage);
    this.$store.commit('common/setPracticeCourt', {
      iframeUrl: iframeUrl?.url || '',
      userId: iframeUrl?.userId || ''
    });
    this.$emit('updateHistory');
  }

  async getIframeUrl() {
    if (this.content.iframePath)
      return {
        url: this.content.iframePath,
        userId: ''
      };
    if (!this.content.type || !this.content.options) {
      this.$Message.error({
        content: '「练习场」对应schema参数要填写完整哦！',
        time: 1500
      });
      return;
    }
    return await initSpecial.call(this, { type: this.content.type, options: this.content.options });
  }
}
</script>
